import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { CommonService, SaveUserSetting, UserSettingFactory } from 'huddyapi';
import { DesktopErrorHandler } from '../../services/errorHandler.service';

@Component({
  selector: 'onboarding-dialog',
  templateUrl: 'onboarding-dialog.component.html',
  styleUrls: ["./onboarding-dialog.component.scss"]
})
export class OnboardingDialog implements OnInit, OnDestroy {
  static HOME_PREFERENCE_SETTING_NAME: string = 'compassBuilderHomePref';
  static HOME_PREFERENCE_DEFAULT_VALUE: string = 'library';
  static HOME_PREFERENCE_LOADING: string = '__LOADING__';

  _working: boolean;
  creating: boolean;
  email: string;
  userSubscription: any;

  set working(value: boolean) {
    this._working = value;
    this.dialogRef.disableClose = value;
  };

  get working(): boolean {
    return this._working;
  };

  constructor(
    private store: Store,
    private errorHandler: DesktopErrorHandler,
    public commonService: CommonService,
    public dialogRef: MatDialogRef<OnboardingDialog>,
    public dialog: MatDialog
  ) {
    this.working = false;
    this.creating = null;
  }

  ngOnInit(): void {
    this.userSubscription = this.commonService.getUserSubject().subscribe((user: any) => this.email = user?.email || '');
  }

  ngOnDestroy(): void {
    if(this.userSubscription?.unsubscribe)
      this.userSubscription.unsubscribe();
  }

  isDisabled(): boolean {
    return this.working || this.isLoading();
  }

  isLoading(): boolean {
    return !(this.email && this.email.length > 0);
  }
  
  setCreating(creating: boolean) {
    if(!this.isDisabled())
      this.creating = creating;
  }

  canSave(): boolean {
    return !this.isDisabled() && this.creating != null;
  }

  save() {
    if(!this.canSave())
      return;
    this.working = true;
    const value: string = this.creating ? 'compasses' : 'library';
    this.store.dispatch(new SaveUserSetting(UserSettingFactory.makeUserSetting(this.email, OnboardingDialog.HOME_PREFERENCE_SETTING_NAME, OnboardingDialog.HOME_PREFERENCE_DEFAULT_VALUE, value, 'STRING', 'COMPASS_SETTING'))).subscribe(() => {
      this.dialogRef.close(value);
    }, (error: any) => {
      this.working = false;
      this.errorHandler.handle(error, 'setting');
    });
  }

  @HostListener('window:keydown', ['$event'])
  handleKeydown(event: any) {
    if(this.dialog.openDialogs?.length > 0 && this.dialog.openDialogs[this.dialog.openDialogs.length - 1] != this.dialogRef)
      return;
    switch(event.key) {
      case 'ArrowLeft':
      case 'ArrowRight':
        event.preventDefault();
        this.setCreating(this.creating == null ? true : !this.creating);
        break;
      case 'Enter':
        event.preventDefault();
        this.save();
        break;
      default:
    }
  }
}
